// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3MaK5","col":"styles_col__2H6lT"};